import React, {Suspense} from 'react'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import SpinnerCustom from '@ui/spinner/SpinnerCustom'
import UserAccessRoot from '@containers/account/access/userAccess/UserAccessRoot'
import {ACCESS_KEYS_VOYAGE_VIEW} from '@containers/account/access/constants/accessList/voyage'
import {VoyageStadiumLazy} from '@containers/voyageStadium/VoyageStadium.lazy'

const VoyageStadiumPage = () => {
    return (
        <PageLayout>
            {/*
              * The stadium board is a read-only screen: StadiumController only asks for
              * acl.voyage.READ. Requiring WRITE here would lock observers out on the frontend
              * where the backend lets them in. Actions inside are gated separately (useStadiumAccess).
              */}
            <UserAccessRoot
                accessType={'or'}
                keys={ACCESS_KEYS_VOYAGE_VIEW}
            >
                <Suspense fallback={<SpinnerCustom/>}>
                    <VoyageStadiumLazy/>
                </Suspense>
            </UserAccessRoot>
        </PageLayout>
    )
}

export default VoyageStadiumPage
